<script setup>
import { ref } from 'vue';
import { useEventListener } from "@vueuse/core";
import BaseModal from '../../headless/BaseModal.vue';
import { useApplicationStore } from '../../../stores/application-store';
import { useBreakpoints } from '../../../composables/breakpoint';
import { track } from '../../../utils/tracking';

const { isMobile } = useBreakpoints();

const open = defineModel('open', { type: Boolean });

const iframeSource = ref(`${import.meta.env.VITE_KARL_URL}/lebenslauf/`);

const application = useApplicationStore();

// Listen to karL iFrame for profile updates
useEventListener(window, 'message', (event) => {
    if (event.data.action !== 'profileUpdated') return;

    track({
        element: 'AP_F: k.at CV',
        elementDetail: 'Updated',
    });
});
</script>

<template>
    <BaseModal
        v-model:open="open"
        data-qa="modal edit cv"
        contains-iframe
        :panel-classes="isMobile ? 'px-l' : ''"
        @after-leave="application.renderCv"
    >
        <template #headline>
            Lebenslauf bearbeiten
        </template>
        <template #default>
            <iframe
                data-qa="iframe"
                class="w-full h-[calc(100%-3.5rem)]"
                sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                :src="iframeSource"
                title="Lebenslauf bearbeiten"
            />
        </template>
    </BaseModal>
</template>
